var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { addMonths, isSameDay, isWithinInterval, isAfter, isBefore, isSameMonth, addYears, max, min } from "date-fns";
import Menu from "./components/Menu";
import { defaultRanges } from "./defaults";
import { parseOptionalDate } from "./utils";
import { MARKERS } from "./markers";
var getValidatedMonths = function (range, minDate, maxDate) {
    var startDate = range.startDate, endDate = range.endDate;
    if (startDate && endDate) {
        var newStart = max([startDate, minDate]);
        var newEnd = min([endDate, maxDate]);
        return [newStart, isSameMonth(newStart, newEnd) ? addMonths(newStart, 1) : newEnd];
    }
    else {
        return [startDate, endDate];
    }
};
var DateRangePickerImpl = function (props) {
    var today = new Date();
    var open = props.open, onChange = props.onChange, initialDateRange = props.initialDateRange, minDate = props.minDate, maxDate = props.maxDate, _a = props.definedRanges, definedRanges = _a === void 0 ? defaultRanges : _a, translation = props.translation;
    var minDateValid = parseOptionalDate(minDate, addYears(today, -10));
    var maxDateValid = parseOptionalDate(maxDate, addYears(today, 10));
    var _b = getValidatedMonths(initialDateRange || {}, minDateValid, maxDateValid), intialFirstMonth = _b[0], initialSecondMonth = _b[1];
    // console.log("rendering DateRangePicker");
    var _c = React.useState(__assign({}, initialDateRange)), dateRange = _c[0], setDateRange = _c[1];
    var _d = React.useState(), hoverDay = _d[0], setHoverDay = _d[1];
    var _e = React.useState(intialFirstMonth || today), firstMonth = _e[0], setFirstMonth = _e[1];
    var _f = React.useState(initialSecondMonth || addMonths(firstMonth, 1)), secondMonth = _f[0], setSecondMonth = _f[1];
    var startDate = dateRange.startDate, endDate = dateRange.endDate;
    // handlers
    var setFirstMonthValidated = function (date) {
        if (isBefore(date, secondMonth)) {
            setFirstMonth(date);
        }
    };
    var setSecondMonthValidated = function (date) {
        if (isAfter(date, firstMonth)) {
            setSecondMonth(date);
        }
    };
    var setDateRangeValidated = function (range) {
        var newStart = range.startDate, newEnd = range.endDate;
        if (newStart && newEnd) {
            range.startDate = newStart = max([newStart, minDateValid]);
            range.endDate = newEnd = min([newEnd, maxDateValid]);
            setDateRange(range);
            onChange(range);
            setFirstMonth(newStart);
            setSecondMonth(isSameMonth(newStart, newEnd) ? addMonths(newStart, 1) : newEnd);
        }
    };
    var onDayClick = function (day) {
        if (startDate && !endDate && !isBefore(day, startDate)) {
            var newRange = { startDate: startDate, endDate: day };
            onChange(newRange);
            setDateRange(newRange);
        }
        else {
            setDateRange({ startDate: day, endDate: undefined });
        }
        setHoverDay(day);
    };
    var onMonthNavigate = function (marker, action) {
        if (marker == MARKERS.FIRST_MONTH) {
            var firstNew = addMonths(firstMonth, action);
            if (isBefore(firstNew, secondMonth))
                setFirstMonth(firstNew);
        }
        else {
            var secondNew = addMonths(secondMonth, action);
            if (isBefore(firstMonth, secondNew))
                setSecondMonth(secondNew);
        }
    };
    var onDayHover = function (date) {
        if (startDate && !endDate) {
            if (!hoverDay || !isSameDay(date, hoverDay)) {
                setHoverDay(date);
            }
        }
    };
    // helpers
    var inHoverRange = function (day) {
        return (startDate &&
            !endDate &&
            hoverDay &&
            isAfter(hoverDay, startDate) &&
            isWithinInterval(day, { start: startDate, end: hoverDay }));
    };
    var helpers = {
        inHoverRange: inHoverRange
    };
    var handlers = {
        onDayClick: onDayClick,
        onDayHover: onDayHover,
        onMonthNavigate: onMonthNavigate
    };
    return open ? (React.createElement(Menu, { dateRange: dateRange, minDate: minDateValid, maxDate: maxDateValid, ranges: definedRanges, firstMonth: firstMonth, secondMonth: secondMonth, setFirstMonth: setFirstMonthValidated, setSecondMonth: setSecondMonthValidated, setDateRange: setDateRangeValidated, helpers: helpers, handlers: handlers, translation: translation })) : null;
};
export var DateRangePicker = DateRangePickerImpl;
//# sourceMappingURL=index.js.map